import React, {useContext, useRef, useState} from "react";
import moment from 'moment';
import TableCell from "./TableCell";
import GlobalContext from "../GlobalContext";

const Calendar = () => {

  const CONTEXT = useContext(GlobalContext);

  function generateTh() {
    let header = [];
    for (let d = 0; d < CONTEXT.DAYS_TRANSLATIONS.length; d++) {
      header.push(
        <th className="py-1 px-1 text-center color-text-orange" key={`ec-th-${d}`}>
          {CONTEXT.DAYS_TRANSLATIONS[d]}
        </th>);
    }
    return <thead>
    <tr>{header}</tr>
    </thead>
  }

  // periodical_report
  // closed_period
  // corporate_event
  // normal
  // it is possible to return array of types when there is more than 1 event
  function calculateDayType(day) {
    let date = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth, day]).format(CONTEXT.dateFormat);
    let event;
    let type = [];

    for (let i = 0; i < CONTEXT.events.length; i++) {
      event = CONTEXT.events[i];
      if (event.days.includes(date)) {
        if (!type.includes(event.type)) {
          type.push(event.type)
        }
      }
    }

    if (type.length > 0) {
      if (type.length === 1) {
        return type[0]
      } else {
        return type;
      }
    } else {
      return 'normal';
    }
  }

  function generateTbody() {
    let rows = [];
    let cells = [];
    let iterator;
    let dayInCurrentMonth = 0;
    let dayInPreviousMonth;
    let dayInNextMonth = 0;

    const DAYS_IN_ROW = 7;
    const WEEKS_AS_ROWS = 6;
    const SELECTED_DATE = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth]);
    const FIRST_WEEKDAY_IN_CURRENT_MONTH = SELECTED_DATE.startOf('month').isoWeekday();
    const DAYS_IN_CURRENT_MONTH = SELECTED_DATE.endOf('month').date();
    const DAYS_IN_PREVIOUS_MONTH = SELECTED_DATE.subtract(1, 'M').endOf('month').date();
    const DAYS_IN_NEXT_MONTH = SELECTED_DATE.add(1, 'M').endOf('month').date();

    // calendar is build from 5x7 cells
    // keep in mind that months are from range 0-11

    // weeks in calendar
    for (let w = 0; w < WEEKS_AS_ROWS; w++) {
      cells = [];
      // days in calendar
      for (let d = 0; d < DAYS_IN_ROW; d++) {
        iterator = d + DAYS_IN_ROW * w + 1;
        dayInPreviousMonth = DAYS_IN_PREVIOUS_MONTH - FIRST_WEEKDAY_IN_CURRENT_MONTH + iterator + 1;
        // current month
        if (iterator >= FIRST_WEEKDAY_IN_CURRENT_MONTH && dayInCurrentMonth < DAYS_IN_CURRENT_MONTH) {
          dayInCurrentMonth++;
          cells.push(<TableCell
            dayNumber={dayInCurrentMonth}
            dayType={calculateDayType(dayInCurrentMonth, CONTEXT.selectedMonth, CONTEXT.selectedYear)}
            monthType="current"
            key={`ec-td-${iterator}`}
          />);
        } else {
          // prev month
          if (iterator < FIRST_WEEKDAY_IN_CURRENT_MONTH) {
            cells.push(<TableCell
              dayNumber={dayInPreviousMonth}
              dayType="normal"
              monthType="previous"
              key={`ec-td-${iterator}`}
            />);
          } else {
            // next month
            dayInNextMonth++;
            cells.push(<TableCell
              dayNumber={dayInNextMonth}
              dayType="normal"
              monthType="previous"
              key={`ec-td-${iterator}`}
            />);
          }
        }
      }
      rows.push(<tr key={`ec-tr-${w}`}>{cells}</tr>);
    }
    return <tbody>{rows}</tbody>
  }

  return (
    <div className="calendar">
      <table className="table-bordered table-xs-smaller-padding">
        {generateTh()}
        {generateTbody(CONTEXT.selectedMonth, CONTEXT.selectedYear, CONTEXT.events)}
      </table>
    </div>
  );
};

export default Calendar;
